module.exports = __webpack_public_path__ + "static/licenses-6d7c8d67789e5c5d971c531cf7d1cf73.jpg";